document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("size-calculator-modal");
  const trigger = document.getElementById("size-calculator-trigger");
  const closeModal = document.querySelector(".close-modal");
  const calculateButton = document.getElementById("calculate-button");
  const sliders = document.querySelectorAll(".vertical-slider");

  // Mapping sizes to road and mountain bike equivalents
  const sizeMappings = {
    "Jr XS": { road: "r12", mtb: "r12" },
    "Jr S": { road: "r14", mtb: "r14" },
    "Jr M": { road: "r16", mtb: "r16" },
    "Jr L": { road: "r20", mtb: "r20" },
    "Jr XL": { road: "r24", mtb: "r24" },
    "XS": { road: "49-50", mtb: "XS" },
    "S": { road: "51-52", mtb: "S" },
    "M": { road: "53-54", mtb: "M" },
    "L": { road: "55-56", mtb: "L" },
    "XL": { road: "57-58", mtb: "XL" },
    "Revisa tus medidas.": { road: "N/A", mtb: "N/A" },
  };

  // Open modal
  trigger.addEventListener("click", () => {
    modal.style.display = "block";
  });

  // Close modal
  closeModal.addEventListener("click", () => {
    modal.style.display = "none";
  });

  // Slider logic with mouse and touch support
  sliders.forEach((slider) => {
    const thumb = slider.querySelector(".slider-thumb");
    const min = parseInt(slider.getAttribute("data-min"));
    const max = parseInt(slider.getAttribute("data-max"));
    const valueDisplay = slider.nextElementSibling;

    const updateThumb = (value) => {
      const percentage = ((value - min) / (max - min)) * 100;
      thumb.style.bottom = `${percentage}%`;
      valueDisplay.textContent = `${value} cm`;
      slider.setAttribute("data-value", value);
    };

    const startInteraction = (event) => {
      event.preventDefault(); // Prevent scrolling
      const rect = slider.getBoundingClientRect();
      const sliderHeight = slider.offsetHeight;

      const handleMove = (e) => {
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        const offset = rect.bottom - clientY;
        const percentage = Math.min(Math.max(offset / sliderHeight, 0), 1);
        const value = Math.round(min + percentage * (max - min));
        updateThumb(value);
      };

      const stopInteraction = () => {
        window.removeEventListener("mousemove", handleMove);
        window.removeEventListener("mouseup", stopInteraction);
        window.removeEventListener("touchmove", handleMove);
        window.removeEventListener("touchend", stopInteraction);
      };

      window.addEventListener("mousemove", handleMove);
      window.addEventListener("mouseup", stopInteraction);
      window.addEventListener("touchmove", handleMove, { passive: false });
      window.addEventListener("touchend", stopInteraction);
    };

    slider.addEventListener("mousedown", (e) => startInteraction(e));
    slider.addEventListener("touchstart", (e) => startInteraction(e), { passive: false });

    updateThumb(parseInt(slider.getAttribute("data-value")));
  });

  // Button Calculate
  calculateButton.addEventListener("click", (e) => {
    e.preventDefault();
    const height = parseInt(document.getElementById("height-slider").getAttribute("data-value"), 10);
    const inseam = parseInt(document.getElementById("inseam-slider").getAttribute("data-value"), 10);

    let size = "Revisa tus medidas.";
    if (height < 85 && inseam < 35) {
      size = "Jr XS";
    } else if (height < 100 && inseam < 40) {
      size = "Jr S";
    } else if (height < 120 && inseam < 50) {
      size = "Jr M";
    } else if (height < 140 && inseam < 60) {
      size = "Jr L";
    } else if (height < 160 && inseam < 70) {
      size = "Jr XL";
    } else if (height >= 160 && height < 170 && inseam >= 70) {
      size = "XS";
    } else if (height >= 170 && height < 180 && inseam >= 75) {
      size = "S";
    } else if (height >= 180 && height < 190 && inseam >= 80) {
      size = "M";
    } else if (height >= 190 && height < 200 && inseam >= 85) {
      size = "L";
    } else if (height >= 200 && inseam >= 90) {
      size = "XL";
    }

    const roadSize = sizeMappings[size]?.road || "N/A";
    const mtbSize = sizeMappings[size]?.mtb || "N/A";

    document.getElementById("size-display").textContent = `Talla: ${size}`;
    document.getElementById("measurements-display").textContent = `Altura: ${height} cm, Entrepierna: ${inseam} cm`;
    document.getElementById("road-size").textContent = `Talla bicicleta:  ruta ${roadSize}`;
    document.getElementById("mtb-size").textContent = `y MTB ${mtbSize}`;
    document.getElementById("size-result").classList.remove("hidden");
  });
});
